import { render, staticRenderFns } from "./tabelaOperacoes.vue?vue&type=template&id=abcd3e62"
import script from "./tabelaOperacoes.vue?vue&type=script&lang=js"
export * from "./tabelaOperacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports